var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-model-item',_vm._g(_vm._b({ref:"div"},'a-form-model-item',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }